import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-ticket-statistics',
    templateUrl: './ticket-statistics.component.html',
    styleUrls: ['./ticket-statistics.component.scss']
})
export class TicketStatisticsComponent implements OnInit {
    @Input() statisticLoaded: boolean = false;
    @Input() statisticsData: any[] = [];
    @Input() periodStart: Date | null = null;
    @Input() periodEnd: Date | null = null;
    @Input() showUserFilter: boolean = false;
    @Input() userUuid: string = '';

    constructor() {}
    ngOnInit(): void {}
}
